import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Popover from 'react-awesome-popover';
import config from '../../../config/config.js';
import axios from 'axios';

class EditLocationGroup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            comment: '',
            open: false,
            loading: false,
            errors: []
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.loadLocationGroup = this.loadLocationGroup.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    handleInputChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleOpen() {
        this.setState({
            open: true,
            errors: [],
            name: '',
            comment: ''
        });
        this.loadLocationGroup();
    }

    handleClose() {
        this.setState({
            name: '',
            comment: '',
            open: false,
            errors: []
        });
        this.props.handleClose();
    }

    loadLocationGroup() {
        let that = this;
        axios(config.server.endpoint + 'backend/location/group/' + this.props.id, {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                that.setState({
                    open: true,
                    name: response.data.name,
                    comment: response.data.comment
                });
            }
        });
    }

    handleSave() {
        this.setState({
            loading: true
        });
        let that = this;
        axios(config.server.endpoint + 'backend/location/group/' + that.props.id, {
            method: 'put',
            data: {
                name: this.state.name,
                comment: this.state.comment
            }
        }).then((response) => {
            if (response.status === 200) {
                that.setState({
                    loading: false
                });
                if(response.data.success === true) {
                    that.handleClose();
                } else {
                    that.setState({
                        errors: response.data.errors
                    });
                }
            }
        });
    }

    render() {
        const { t } = this.props;
        return (
            <Popover onOpen={this.handleOpen} onClose={this.handleClose} open={this.state.open} contentClass="rap-popover-content">
                <a>
                    <i className="fa fa-pencil fa-1-5x"/>
                </a>
                <div className="p-md" style={{width: 500, textAlign: 'left'}}>
                    <div
                        className="form-group">
                        <label>{t('locationGroup.name.label')}</label>
                        <input type="text" name="name" className="form-control" value={this.state.name} onChange={this.handleInputChange}/>
                        {(this.state.errors && this.state.errors.name) ? (
                            <span className="help-block">
                                {t('locationGroup.name.error.' + this.state.errors.name)}
                            </span>
                        ) : null}
                    </div>
                    <div
                        className="form-group">
                        <label>{t('locationGroup.comment.label')}</label>
                        <textarea name="comment" className="form-control" value={this.state.comment} onChange={this.handleInputChange}/>
                        {(this.state.errors && this.state.errors.comment) ? (
                            <span className="help-block">
                                {t('locationGroup.comment.error.' + this.state.errors.comment)}
                            </span>
                        ) : null}
                    </div>
                    <button className="btn btn-small btn-primary" onClick={this.handleSave}>
                        <i className="fa fa-save m-r-sm"/>
                        {t('default.save')}
                    </button>
                </div>
            </Popover>
        )
    }
}

export default translate()(EditLocationGroup);